<template>
  <div>
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      title="扣税规则设置"
      destroy-on-close
      :visible.sync="show"
      :before-close="handleClose"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content" style="padding: 20px">
        <el-form ref="form" :model="form" label-width="160px" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="应缴增值税计算规则(一般计税)" prop="yjzzs_normal">
                <el-input v-model="form.yjzzs_normal" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('yjzzs_normal')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="分包差额抵税(简易计税)" prop="fbceds_easy">
                <el-input v-model="form.fbceds_easy" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('fbceds_easy')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="应缴增值税计算规则(简易计税)" prop="yjzzs_easy">
                <el-input v-model="form.yjzzs_easy" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('yjzzs_easy')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="应缴增值税是否允许负数" prop="yjzzs_allow_negative">
                <el-radio-group v-model="form.yjzzs_allow_negative">
                  <el-radio v-for="item in dimensionOptions" :label="item.key" :key="item.key">{{ item.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="应缴增值税（本地）" prop="yjzzs_local">
                <el-input v-model="form.yjzzs_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('yjzzs_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="应缴增值税（本地）是否允许负数" prop="yjzzs_local_allow_negative">
                <el-radio-group v-model="form.yjzzs_local_allow_negative">
                  <el-radio v-for="item in dimensionOptions" :label="item.key" :key="item.key">{{ item.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="城建税（本地）抵扣规则" prop="cjs_local">
                <el-input v-model="form.cjs_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('cjs_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="教育费附加（本地）抵扣规则" prop="jyffj_local">
                <el-input v-model="form.jyffj_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('jyffj_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="地方教育费附加（本地）抵扣规则" prop="dfjyffj_local">
                <el-input v-model="form.dfjyffj_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('dfjyffj_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="印花税（本地）抵扣规则" prop="yhs_local">
                <el-input v-model="form.yhs_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('yhs_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="个人所得税（本地）抵扣规则" prop="grsds_local">
                <el-input v-model="form.grsds_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('grsds_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="水利基金（本地）抵扣规则" prop="sljj_local">
                <el-input v-model="form.sljj_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('sljj_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="防洪基金（本地）抵扣规则" prop="fhjj_local">
                <el-input v-model="form.fhjj_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('fhjj_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="其他地方基金（本地）抵扣规则" prop="qtdfjj_local">
                <el-input v-model="form.qtdfjj_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('qtdfjj_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="企业所得税（本地）抵扣规则" prop="qysds_local">
                <el-input v-model="form.qysds_local" type="textarea" @blur="blurEvent"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-link type="primary" :underline="false" @click="chooseCustom('qysds_local')">选择变量</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="合同未签约" prop="contract_no_sign_tax">
                <el-radio-group v-model="form.contract_no_sign_tax">
                  <el-radio v-for="item in portalTypeOptions" :label="item.value" :key="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
    <form-field-selector ref="formFieldSelector" :isShowCustom="isShowCustom" @setField="(params) => setField(params, chooseName)"></form-field-selector>
  </div>
</template>

<script>
import formFieldSelector from './formFieldSelector.vue'
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  components: { formFieldSelector },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    noticeData: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate
    })
  },
  watch: {
    noticeData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = Object.assign({}, this.form, newVal)
        }
      }
    }
  },
  data() {
    return {
      drawerSize: '70%',
      tenantId: '-1',
      loading: false,
      showPerson: false,
      noticeTimeShow: false,
      form: {
        yjzzs_normal: '',
        fbceds_easy: '',
        yjzzs_easy: '',
        yjzzs_allow_negative: '0',
        yjzzs_local: '',
        yjzzs_local_allow_negative: '0',
        cjs_local: '',
        jyffj_local: '',
        dfjyffj_local: '',
        yhs_local: '',
        grsds_local: '',
        sljj_local: '',
        fhjj_local: '',
        qtdfjj_local: '',
        qysds_local: '',
        contract_no_sign_tax: '0'
      },
      dimensionOptions: [],
      bodefOptions: [],
      targetNameOptions: [],
      conditionOperatorOptions: [
        { value: 'GT', label: '大于' },
        { value: 'LT', label: '小于' },
        { value: 'GE', label: '大于等于' },
        { value: 'LE', label: '小于等于' },
        { value: 'EQ', label: '等于' },
        { value: 'NE', label: '不等于' },
        { value: 'LKS', label: '左相似' },
        { value: 'LKE', label: '右相似' },
        { value: 'IN', label: '包含' },
        { value: 'BETWEEN_CONTAIN_BEHIND', label: '介于(含后值)' },
        { value: 'BETWEEN_CONTAIN_FRONT', label: '介于(含前值)' },
        { value: 'BETWEEN', label: '介于(含前后值)' },
        { value: 'BETWEEN_NO_CONTAIN', label: '介于(不含前后值)' }
      ],
      rules: {
        yjzzs_local_allow_negative: [
          {
            required: true,
            message: '请选择应缴增值税（本地）是否允许负数',
            trigger: 'change'
          }
        ],
        contract_no_sign_tax: [{ required: true, message: '请选择合同未签约', trigger: 'change' }]
      },
      blurIndex: null,
      // 显示门户页面
      portalTypeOptions: [],
      // 显示单位
      showUnitOptionsOwn: [],
      showUnitOptionsMoney: [],
      // 显示统计数据
      statisticsDataOptions: [],
      treeData: [],
      chooseName: '',
      // 加上应缴增值税-YYJZZS，根据计算规则计算的该项目应该缴纳的增值税，前三个选择不到
      isShowCustom: true
    }
  },
  mounted() {
    let that = this
    that.$nextTick(() => {
      that.portalTypeOptions = utils.getAllEnumerateAttr({
        isShowList: true,
        typeKey: 'ContractNoSignTax',
        allData: that.allEnumerate
      })
      that.dimensionOptions = utils.findDictList('sfdy1', that.allDataDict)
    })
  },
  methods: {
    chooseCustom(name) {
      this.isShowCustom = ['yjzzs_normal', 'fbceds_easy', 'yjzzs_easy'].includes(name)
      this.chooseName = name
      this.$refs.formFieldSelector.showDialog()
    },
    //input框记录光标位置
    blurEvent(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    //设置提醒时间
    showNoticeTime() {
      this.noticeTimeShow = true
    },
    closeNoticeTime(val) {
      if (val) {
        this.form.remind_time = val
      }
      this.noticeTimeShow = false
    },
    //变量选择
    setField(val, name) {
      let str = `{${val.label}:${val.value}}`
      this.form[name] = this.form[name].slice(0, this.blurIndex) + str + this.form[name].slice(this.blurIndex)
    },
    //重置必填项
    resetFields() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    //提醒方式多选
    remindWayChange(val) {
      let str = ''
      if (val) {
        val.forEach((item) => {
          str += item + ','
        })
        str = str.substring(0, str.length - 1)
      }
      this.form.remind_way = str
    },
    //提醒方式多选
    portalTypeChange(val) {
      let str = ''
      if (val) {
        val.forEach((item) => {
          str += item + ','
        })
        str = str.substring(0, str.length - 1)
      }
      this.form.portal_type = str
    },
    //维度选中后联动模板
    dimensionChange(val) {
      this.form.bo_def_key = ''
      this.form.target_key = ''
      this.bodefOptions = []
      this.targetNameOptions = []
      this.dimensionOptions.forEach((item) => {
        if (item.value == val) {
          this.form.dimension = item.label
        }
      })
      this.$http.get('${risk}/rule/business_reminder/getModuleByDimensionKey?key=' + val).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            this.bodefOptions.push({
              value: item.bo_def_key,
              label: item.bo_def
            })
          })
        }
      })
    },
    //模板选中后联动指标
    boDefChange(val) {
      this.form.target_key = ''
      this.targetNameOptions = []
      this.bodefOptions.forEach((item) => {
        if (item.value == val) {
          this.form.bo_def = item.label
        }
      })
      this.$http.get('${risk}/rule/business_reminder/getTargetByModuleKey?key=' + val).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            this.targetNameOptions.push({
              value: item.target_key,
              label: item.target_name
            })
          })
        }
      })
    },
    //指标选中
    targetChange(val) {
      this.targetNameOptions.forEach((item) => {
        if (item.value == val) {
          this.form.target_name = item.label
        }
      })
    },
    //统计数据
    statisticsDataChange() {},
    //关闭表单
    handleClose() {
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      this.loading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .post('${portal}/portal/data_switch_config/createDeductionRule', this.form)
            .then((res) => {
              if (res.data.state) {
                this.loading = false
                this.$message.info('保存成功！')
              } else {
                this.loading = false
                this.$message.error('保存失败！')
              }
              this.handleClose()
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.loading = false
          return false
        }
      })
    },
    //设置提醒人
    setPerson() {
      this.showPerson = true
    },
    //设置提醒人关闭
    close() {
      this.showPerson = false
    },
    onConfirm(val, sonTable, str) {
      this.form.reminder_members = str
      this.form.sub_business_reminder_member = sonTable
      this.showPerson = false
    }
  }
}
</script>

<style scoped></style>
